import { ForgotPassword } from 'app/pages/ForgotPassword'
import { Login } from 'app/pages/Login'
import { PageNotFound } from 'app/pages/PageNotFound'
import { ResendConfirmUserEmail } from 'app/pages/ResendConfirmUserEmail'
import { ResetPassword } from 'app/pages/ResetPassword'
import { Signup } from 'app/pages/Signup'
import { UserConfirm } from 'app/pages/UserConfirm'
import React from 'react'
import { Route, Switch } from 'react-router-dom'

import { HandledRoute } from './HandledRoute'
import { getProtectedRoutes, getPublicRoutes, routes } from './routes'

const PublicAppRouter = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path={getPublicRoutes()}>
        {/* <Layout> */}
        <Switch>
          <HandledRoute exact path={routes.signup.path}>
            <Signup />
          </HandledRoute>
          <HandledRoute exact path={routes.login.path}>
            <Login />
          </HandledRoute>
          <HandledRoute exact path={routes.forgotPassword.path}>
            <ForgotPassword />
          </HandledRoute>
          <HandledRoute exact path={routes.resendConfirmUserEmail.path}>
            <ResendConfirmUserEmail />
          </HandledRoute>
          <HandledRoute exact path={routes.userConfirm.path}>
            <UserConfirm />
          </HandledRoute>
          <HandledRoute exact path={routes.invitationConfirm.path}>
            <Signup isInvitation />
          </HandledRoute>
          <HandledRoute exact path={routes.resetPassword.path}>
            <ResetPassword />
          </HandledRoute>
        </Switch>
      </Route>

      {/* Render Login on protected routes */}
      <HandledRoute exact path={getProtectedRoutes()}>
        <Login />
      </HandledRoute>

      <Route path='*'>
        <PageNotFound />
      </Route>
    </Switch>
  )
}

export default PublicAppRouter
